import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {GroupModel} from "../../models/group.model";

@Injectable({providedIn: 'root'})
export class GroupsHttpService {

  private base_url = `/groups`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getGroups(params?: any): Observable<{ cursor: string, list: GroupModel[] }> {
    return this.http
      .get<{ cursor: string, list: GroupModel[] }>(this.base_url, {params});
  }

}
